import { clients } from '../../../lib/https';
import { ConfigurationSettings } from '../../../models/configuration-settings';

interface FeedbackResponse {
  modified_count: number;
  message: string;
  status: string;
}

interface FeedbackParams {
  conversation_id: string;
  msg_id: string;
  feedback: boolean;
}

export const sendFeedback = async (
  param: FeedbackParams,
  config: ConfigurationSettings
): Promise<FeedbackResponse> => {
  const payload = {
    conversation_id: param.conversation_id,
    msg_id: param.msg_id,
    feedback: param.feedback,
  };

  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.feedback}`;
  return clients.post(url, config.blocksKey, JSON.stringify(payload));
};
